module.exports = __webpack_public_path__ + "static/media/shape_L.8670fb1d.glb";